<template>
  <v-flex>
    <v-card>
      <v-card-title class="justify-center title purple--text font-weight-bold">{{$t('Your devices')}}</v-card-title>
      <v-card-text>
        <v-data-table
          hide-actions
          disable-initial-sort
          :headers="tableHeaders"
          :items="devices"
          class="devices-table"
        >
          <template slot="items" slot-scope="props">
            <td class="font-weight-medium">{{props.item.number}}</td>
            <td
              class="font-weight-medium"
              style="min-width: 150px"
            >{{props.item.status_physical | transformStatus}}</td>
            <td class="font-weight-medium">
              <!-- {{props.item.video_count}}
              <span class="sync-date">{{props.item.sync_date}}</span>-->
              <v-tooltip light right>
                <span slot="activator">{{props.item.video_count > 0 ? props.item.video_count : 0}}</span>
                <span>{{$t('server time:')}} {{props.item.sync_date}}</span>
              </v-tooltip>
            </td>
            <td class="font-weight-medium">{{props.item.date_exp}}</td>
            <td class="font-weight-medium text-xs-center">
              <!-- <v-btn
                dark
                v-if="(props.item.cancel_subscription === 'null' || props.item.cancel_subscription == 0) && (props.item.subscription && props.item.subscription !== 'null')"
                color="purple"
                @click="subscription(props.item.number)"
              >{{$t('subscription')}}</v-btn> -->
              <!-- ((parseDate(getCurrentDate)) < (parseDate(props.item.date_exp))) -->
              <!-- <v-btn
                dark
                v-if="(props.item.cancel_subscription == 1) && (props.item.subscription && props.item.subscription !== 'null')"
                color="purple"
                @click="cancelSubscription(props.item.number, props.item.status_physical)"
              >{{$t('cancel subscription')}}</v-btn> -->
              <!-- plan_EPI31KlvEfI00F -->
              <input
                value="plan_Eg4ujcY4v7NLeZ"
                type="text"
                style="border: 1px solid grey; display: none"
                :ref="'subscription-' + props.item.number"
              >
              <!-- <v-btn
                dark
                color="purple"
                v-if="props.item.buy_glasses && (!props.item.subscription || props.item.subscription === 'null')"
                @click="openPromoModal(props.item.number)"
              >{{$t('pay with card')}}</v-btn> -->
              <!-- v-if="!props.item.buy_glasses && (!props.item.subscription || props.item.subscription === 'null')" -->
              <v-btn
                dark
                color="purple"
                @click="buyVideos(props.item.number)"
              >{{$t('buy videos')}}</v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="add-device">
        <form action="#">
          <v-layout justify-center wrap align-center>
            <v-flex class="form-wrap">
              <label for="cardId">{{$t('Add device')}}</label>
              <input type="text" id="cardId" min="20" v-model="newDevice">
            </v-flex>
            <v-btn outline color="purple" @click="submit" dark>{{$t('ACTIVATE')}}</v-btn>
          </v-layout>
        </form>
      </v-card-actions>
    </v-card>
    <!-- <v-dialog v-model="errorDialog" max-width="350">
      <v-card style="padding-bottom: 0" class="text-xs-center">
        <v-card-title class="justify-center text-xs-center">{{errorMsg}}</v-card-title>
        <v-btn dark color="purple" v-if="errorBtnText" @click="errorDialog=false">{{errorBtnText}}</v-btn>
      </v-card>
    </v-dialog>-->
    <promoStepper v-model="showPromoStep" :device_id="promoDeviceId" :email="email"></promoStepper>
    <showModal
      v-model="error.show"
      :message="error.msg"
      :buttonText="error.btnText"
      :secondaryBtnText="error.secondaryText"
      @on-apply="sendCancelSubscription(error.device_id)"
      @on-secondaryApply="error.show = false"
    ></showModal>
  </v-flex>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import showModal from "@/components/ShowModal";
import promoStepper from "@/components/promoStepper";
// import { createStripeBtn } from "@/utils";

export default {
  components: {
    showModal,
    promoStepper
  },

  data: () => ({
    newDevice: "",
    error: {},
    numberToChange: "",
    email: '',
    btns: "",
    tableHeaders: [
      { text: Vue.i18n.translate('Number'), value: "id", sortable: false },
      { text: Vue.i18n.translate('Status'), value: "status", sortable: false },
      { text: Vue.i18n.translate('Number of views'), value: "video_count", sortable: false },
      { text: Vue.i18n.translate('Expiration date'), value: "date_exp", sortable: false },
      { text: "", value: "usability", sortable: false }
    ],
    devices: [
      { number: NaN, status: "none", video_count: "Unlimited", in_use: "none" }
    ],
    showPromoStep: false,
    promoDeviceId: '',
    stripeProps: {
      amount: "",
      currency: "",
      stripeKey: ""
    }
  }),

  created() {
    this.init();
  },

  methods: {
    submit() {
      axios
        .post(
          this.$hostname + "/client/devices",
          {
            number: this.newDevice
          },
          {
            headers: {
              Authorization: localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          console.log(response);
          if (response.status === 200) {
            this.init();
          }
        })
        .catch(error => {
          (this.error = {}), (this.error.show = true);
          this.error.msg = `${
            this.$t(this.$store.getters.errorsList[error.response.data.message])
          }`;
        });
    },

    init() {
      axios
        .get(this.$hostname + "/client/devices", {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
          this.devices = response.data.data;
          return axios.get(this.$hostname + "/stripe/credentials/buy");
        })
        .then(response => {
          console.log(response);
          return axios.get(this.$hostname + "/client/me/", {
            headers: {
              Authorization: localStorage.getItem("token")
            }
          });
        })
        .then(response => {
          this.email = response.data.data.email
        })
    },

    subscription(deviceId) {
      this.error.show = false;
      this.error.btnText = null;
      this.error.secondaryText = null;
      let formData = new FormData();
      formData.append("planId", this.$refs["subscription-" + deviceId].value);
      axios
        .post(
          this.$hostname + "/stripe/subscription/create/" + deviceId,
          formData
        )
        .then(response => {
          console.log(response);
          let message = this.$t('Invoice will be sent to your email. It will be delivered within 1 hour. Please, proceed with payment using your email');
          this.showMessage(message);
          this.init();
        })
        .catch(error => {
          this.error.msg = `${
            this.$t(this.$store.getters.errorsList[error.response.data.message])
          }`;
          this.error.show = true;
        });
    },

    cancelSubscription(number, status_physical) {
      if (status_physical == 2) {
        this.error.show = true;
        this.error.msg = this.$t('You have subscription. Are you sure that you want to cancel subscription?');
        this.error.btnText = this.$t("ok");
        this.error.device_id = number;
        this.error.secondaryText = this.$t("cancel");
        this.init();
      } else {
        this.error.show = true;
        this.error.msg = this.$t("Invoice was already sent and was not paid yet. Do you want to cancel?");
        this.error.btnText = this.$t("ok");
        this.error.device_id = number;
        this.error.secondaryText = this.$t("cancel");
        this.init();
      }
    },

    charge() {
      let message = this.$t("Please, open your app and switch on Wi-Fi on VR glasses to update the views counts. Once it is updated, you will be able to buy views here clicking on the same button");
      this.showMessage(message);
      this.init();
    },

    buyVideos(device_id) {
      axios
        .get(this.$hostname + "/stripe/sync_date/" + device_id)
        .then(response => {
          console.log(response);
          if (response.data.message !== "ok") {
            let message = this.$t("Please, open your app and switch on Wi-Fi on VR glasses to update the views counts. Once it is updated, you will be able to buy views here clicking on the same button");
            this.showMessage(message);
          } else {
            this.$router.push("/view/" + device_id);
          }
        })
        .catch(error => {
          this.error.msg = `${
            this.$t(this.$store.getters.errorsList[error.response.data.message])
          }`;
          this.error.show = true;
        });
    },

    parseDate(date) {
      return Date.parse(date);
    },

    sendCancelSubscription(device_id) {
      console.log(device_id);
      this.error.show = false;
      this.error.btnText = null;
      this.error.secondaryText = null;
      let formData = new FormData();
      formData.append("device_id", device_id);
      axios
        .post(this.$hostname + "/client/subscription/cancel", formData, {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
          let message = this.$t("You canceled subscription");
          let btnText = this.$t("ok");
          this.showMessage(message, btnText);
          this.init();
        })
        .catch(error => {
          this.error.msg = `${
            this.$t(this.$store.getters.errorsList[error.response.data.message])
          }`;
          this.error.show = true;
        });
    },

    openPromoModal (device_id) {
      this.promoDeviceId = device_id
      this.showPromoStep = true
    },

    showMessage(message, btnText) {
      this.error.show = true;
      this.error.msg = message;
      this.error.btnText = btnText;
    }
  },

  computed: {
    getCurrentDate() {
      return new Date();
    }
  },

  filters: {
    lowerCase: value => {
      if (!value) {
        return "";
      }
      return (value = value.toLowerCase());
    },

    transformDate: value => {
      return Date.parse(value);
    },

    transformStatus: value => {
      let phisicalStatusList = [
        Vue.i18n.translate("In Stock"),
        Vue.i18n.translate("Awaiting for Activation"),
        Vue.i18n.translate("Activated")
      ];
      return phisicalStatusList[value];
    }
  }
};
</script>

<style scoped lang="scss">
.v-card {
  padding-bottom: 30px;
}

.title {
  font-size: 19px !important;
  padding-top: 30px;
}

.add-device {
  form {
    width: 100%;
  }

  .form-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
    width: 100%;
    @media (max-width: 600px) {
      flex-wrap: wrap;
    }
  }

  label {
    font-weight: 700;
    font-size: 18px;
    margin-right: 25px;
    @media (max-width: 600px) {
      width: 100%;
      text-align: center;
      margin-bottom: 10px;
    }
  }

  input {
    background-color: #f5f5f5;
    max-width: 320px;
    width: 100%;
    padding: 10px 15px;
    text-align: center;
  }
}
</style>